import {applyMiddleware, combineReducers, createStore} from "redux";
import createSagaMiddleware from 'redux-saga'
import {composeWithDevTools} from "redux-devtools-extension";
import {organizationsReducer} from "./organizations/reducers";
import {bannerTemplatesReducer} from "./banner/template/reducers";
import { logger } from 'redux-logger';
import rootSaga from './rootSaga'
import {connectRouter, routerMiddleware, RouterState} from 'connected-react-router'
import {createBrowserHistory, History} from "history";
import {IBannerTemplateState} from "./banner/template/types";
import {OrganizationsState} from "./organizations/types";
import {IFeedState} from "./feed/types";
import {feedReducer} from "./feed/reducers";
import {bannerVariablesReducer} from "./banner/variables/reducers";
import {IBannerVariablesState} from "./banner/variables/types";
import {userReducer} from "./user/reducers";
import {IUserState} from "./user/types";
import {bannerSassReducer} from "./banner/sass/reducers";
import {IBannerSassState} from "./banner/sass/types";
import {IFileSystemState} from "./files/types";
import {filesReducer} from "./files/reducers";
import {fetchAllFilesAsyncActions} from "./files/actions";
import {createAxiosAuthMiddleware} from "./middlewares/auth";
import {loadFeedsAsyncActions} from "./feed/actions";


const sagaMiddleware = createSagaMiddleware();

const createRootReducer = (history: History) => combineReducers({
    router: connectRouter(history),
    bannerTemplates: bannerTemplatesReducer,
    bannerVariables: bannerVariablesReducer,
    bannerSass: bannerSassReducer,
    filesSystem: filesReducer,
    organizations: organizationsReducer,
    feed: feedReducer,
    user: userReducer,
});

export type AppState = {
    bannerTemplates: IBannerTemplateState;
    bannerVariables: IBannerVariablesState;
    bannerSass: IBannerSassState;
    filesSystem: IFileSystemState;
    organizations: OrganizationsState;
    feed: IFeedState;
    router: RouterState,
    user: IUserState,
}

export const history = createBrowserHistory()

export function configureStore(preloadedState?:any) {
    const middlewares = [createAxiosAuthMiddleware(), sagaMiddleware, logger, routerMiddleware(history)];
    const middleWareEnhancer = applyMiddleware(...middlewares)

    return createStore(
        createRootReducer(history), // root reducer with router state
        preloadedState,
        composeWithDevTools(middleWareEnhancer)
    );
}

const store = configureStore();
sagaMiddleware.run(rootSaga);

store.dispatch(loadFeedsAsyncActions.request({}))
store.dispatch(fetchAllFilesAsyncActions.request({}))

export default store;
